import { Camera } from "lucide-react";

const loads = [
  {
    label: "¼ Load",
    capacity: "2.1 m³",
    fill: 25,
    machines: "≈ 4 washing machines",
    desc: "A small clean-out or collection of household rubbish.",
  },
  {
    label: "½ Load",
    capacity: "4.2 m³",
    fill: 50,
    machines: "≈ 8 washing machines",
    desc: "A medium clean-out with several bulky household items.",
  },
  {
    label: "¾ Load",
    capacity: "6.3 m³",
    fill: 75,
    machines: "≈ 12 washing machines",
    desc: "A larger household, garage or move-out clear-out.",
  },
  {
    label: "Full Load",
    capacity: "8.4 m³",
    fill: 100,
    machines: "≈ 16 washing machines",
    desc: "A substantial clear-out with furniture, junk and bulky items.",
  },
];

const LoadSizeGuide = () => (
  <section id="load-sizes" className="scroll-mt-28 bg-white py-16 md:py-24">
    <div className="container">
      <h2 className="text-3xl md:text-4xl font-black text-[#1a1a1a] text-center mb-3">
        How Much Rubbish Have You Got?
      </h2>
      <p className="text-center text-[#1a1a1a]/70 mb-12 md:mb-14 max-w-xl mx-auto">
        Use the guide below as a rough estimate. Not sure? Send us photos.
      </p>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {loads.map((l) => (
          <div
            key={l.label}
            className="h-full bg-card rounded-xl p-7 border border-[#1a1a1a]/8 hover:border-orange hover:bg-orange-soft hover:shadow-lg transition-all"
          >
            {/* Simple truck-body fill indicator */}
            <div className="h-16 w-full rounded-lg border-2 border-[#1a1a1a]/15 bg-[#1a1a1a]/[0.03] p-1.5 flex items-end gap-1.5 mb-5">
              <div
                className="h-full rounded-md bg-gradient-to-t from-orange to-[#FDC00E]"
                style={{ width: `${l.fill}%` }}
                aria-hidden="true"
              />
            </div>
            <div className="flex flex-wrap items-center gap-2 mb-1">
              <h3 className="text-2xl font-black text-[#1a1a1a]">{l.label}</h3>
              <span className="inline-flex items-center rounded-md bg-[#1a1a1a]/[0.06] px-2 py-1 text-sm font-semibold text-[#1a1a1a]/55">
                {l.capacity}
              </span>
            </div>
            <p className="text-lg font-bold text-orange mb-2">{l.machines}</p>
            <p className="text-[#1a1a1a]/70 text-sm leading-relaxed">{l.desc}</p>
          </div>
        ))}
      </div>

      <p className="mt-8 text-center text-[#1a1a1a]/50 text-sm max-w-2xl mx-auto">
        Volume guide only, actual capacity may vary depending on item size, shape and how efficiently items can be loaded.
      </p>

      <div className="mt-12 text-center">
        <a
          href="/#quote"
          className="inline-flex items-center justify-center gap-2 bg-[#1a1a1a] text-white px-8 py-4 text-lg font-bold rounded-md hover:bg-orange transition-colors"
        >
          <Camera className="w-5 h-5 shrink-0" />
          Upload Photos for a Quote
        </a>
      </div>
    </div>
  </section>
);

export default LoadSizeGuide;
